// src/features/social/WeeklyXpChart.jsx
// ─────────────────────────────────────────────────────────────────────────────
// Componentes compartilhados entre UserProfileOffcanvas e PerfilUser
// ─────────────────────────────────────────────────────────────────────────────
import React from "react";

export function WeeklyXpChart({ data = [], chartStyle }) {
  const maxXp = Math.max(...data.map((d) => d.xp), 1);
  const W     = 320;
  const H     = 80;
  const FOOT  = 18;
  const barW  = 34;
  const gap   = (W - 7 * barW) / 6;
  const baseX = 0;

  return (
    <svg
      width="100%"
      viewBox={`0 0 ${W} ${H + FOOT}`}
      preserveAspectRatio="xMidYMid meet"
      className={chartStyle}
    >
      {data.map((d, i) => {
        const barH  = Math.max((d.xp / maxXp) * H, d.xp > 0 ? 6 : 2);
        const x     = baseX + i * (barW + gap);
        const y     = H - barH;
        const fill  = d.isToday
          ? "var(--color-accent, #FBBC04)"
          : "var(--color-primary, #1428A0)";
        const alpha = d.xp > 0 ? (d.isToday ? 1 : 0.65) : 0.1;

        return (
          <g key={d.date}>
            <rect
              x={x} y={y}
              width={barW} height={barH}
              rx={5} fill={fill} opacity={alpha}
            />
            {d.xp > 0 && (
              <text
                x={x + barW / 2} y={y - 4}
                textAnchor="middle"
                fontSize={8}
                fontWeight="700"
                fill="var(--color-primary, #1428A0)"
              >
                {d.xp}
              </text>
            )}
            <text
              x={x + barW / 2} y={H + FOOT - 1}
              textAnchor="middle"
              fontSize={9}
              fontWeight={d.isToday ? "700" : "500"}
              fill={d.isToday ? "var(--color-accent, #FBBC04)" : "#9ca3af"}
            >
              {d.day}
            </text>
          </g>
        );
      })}
    </svg>
  );
}

export function XpStatRow({ weekly = 0, monthly = 0, total = 0, styles = {} }) {
  const items = [
    { label: "Esta semana", value: weekly  },
    { label: "Este mês",    value: monthly },
    { label: "XP total",    value: total   },
  ];
  return (
    <div className={styles.xpStatRow}>
      {items.map((item, i) => (
        <div key={i} className={styles.xpStatCol}>
          <span className={styles.xpStatValue}>
            {Number(item.value || 0).toLocaleString("pt-BR")}
          </span>
          <span className={styles.xpStatLabel}>{item.label}</span>
        </div>
      ))}
    </div>
  );
}